import React, { ComponentPropsWithoutRef, ComponentPropsWithRef } from 'react';
import { Button, IconButton, SvgIconTypeMap, Tabs } from '@mui/material';
import { ButtonType } from '../../Utilities/Enums/ButtonTypeEnum';
import { ViewType } from '../../Utilities/Enums/ViewTypeEnum';

import { CheckoutData } from '../../Models/Billing/Billing';

export type CustomButtonInterface = {
    btnType: ButtonType;
    // title: string;
    title?: React.ReactNode | string | any;
    ref?: any;

    isDefault?: boolean;
    // startIcon?: any;
    // endIcon?: any,
    navigationLink?: any;
    btnStyle?: any;
    width?: string,
    fullWidth?: boolean;
    isRoundedCorner?:boolean;
} & ComponentPropsWithoutRef<typeof Button>;

export type CustomIconButtonInterface = {
    toolTipName: string,
    icon: any,
    onClick: any,
    iconColor?: any,
} & ComponentPropsWithoutRef<typeof IconButton>;

export type CustomTabsInterface = {
    selectedTab: any,
    handleOnChange: any,
    items: { id: any, name: string }[]
} & ComponentPropsWithoutRef<typeof Tabs>;

export interface CustomDrawerInterface {
    anchor?: any;
    OpenDrawer?: any;
    setOpenDrawer?: any;
    children?: React.ReactNode;
    disablePortal?: boolean;
}

export interface CustomTooltipInterface {
    tooltipName?: any,
    placement?: any,
    tooltipContent?: any,
    tooltipClass?: any,
}

export interface CustomPopoverInterface {
    open?: boolean,
    anchorEl?: any,
    handleClose?: any,
    aoVerticalAlign?: string,
    aoHorizontalAlign?: any,
    toVerticalAlign?: any,
    toHorizontalAlign?: string,
    disablePortal?: boolean,
    children?: React.ReactNode;
}

export interface CustomDeleteConfirmationInterface {
    open?: boolean,
    setOpen?: any,
    deleteItem?: any,
}

export interface CustomDialogInterface {
    title: string,
    subtitle?: string,
    openDialog?: boolean,
    setOpenDialog?: (open: boolean) => void,
    children?: React.ReactNode | string,
    dialogClassName?: any,
    clearDialog?: (item?: any) => void,
    onCloseDialog: (item?: any) => void,
    isDeleteConfirmation?: boolean,
    disablePortal?: boolean,
    actionButtons?: React.ReactNode | string,
}

export interface CustomContainerInterface {
    containerClassName?: any;
    children: React.ReactNode;
    borderTop?: boolean;
    borderBottom?: boolean;
    borderLeft?: boolean;
    borderRight?: boolean;
    borderRadius?: any;
    containerWidth?: any;
}

export interface DetailsPageContainerInterface {
    containerClassName?: any;
    children?: React.ReactNode;
}

export interface CustomPrevNextInterface {
    onClickPrev?: (item: any) => void;
    onClickNext?: (item: any) => void;
    onClickMenu?: (item: any) => void;
}

export interface CustomHeaderTitleInterface extends CustomPrevNextInterface {
    showPrevNext?: boolean,
    children: React.ReactNode,
}

export class ConfirmDeleteDialogModel {
    openDialog?: boolean = false;
    handleClose: () => void = () =>{};
    deleteItem: (remarks: any) => void = (remarks: any) =>{};
    ItemToDelete?: string | null = 'this item';
    showRemarksField?: boolean = false;

    constructor(obj?: Partial<ConfirmDeleteDialogModel>) {
        Object.assign(this, obj);
    }
}

export class CustomTitlesInterface {
    titleHeader?: string = "";
    titleValue?: string = "";

    constructor(obj?: Partial<CustomTitlesInterface>) {
        Object.assign(this, obj);
    }
}

export class LicenseKeyTitleInterface {
    licenseKey?: string = "";
    isWithCopyBtn?: boolean = false;
    color?: string = 'info';
    // onClickLicenseKey?: () => void = () =>{};
    linkUrl?: any;

    constructor(obj?: Partial<LicenseKeyTitleInterface>) {
        Object.assign(this, obj);
    }
}

export class CustomDetailsHeaderInterface {
    // title?: string = "";
    title?: React.ReactNode | string = null;
    actionButtons?: React.ReactNode = null;
    isNoPadding?: boolean = false;
    isTitleNotText?: boolean = false;

    constructor(obj?: Partial<CustomDetailsHeaderInterface>) {
        Object.assign(this, obj);
    }
}

export class CustomDetailsCardInterface {
    // title?: string | React.ReactNode = "";
    title?: React.ReactNode | string = null;
    actionButtons?: React.ReactNode = null;
    children: React.ReactNode = null;
    isNoPadding?: boolean = false;
    isTitleNotText?: boolean = false;
    isInvoiceDetails?: boolean = false;

    constructor(obj?: Partial<CustomDetailsCardInterface>) {
        Object.assign(this, obj);
    }
}

export class BuyLicenseHeaderInterface {
    headerTitle?: string = "";
    headerSubTitle?: string = "";

    constructor(obj?: Partial<BuyLicenseHeaderInterface>) {
        Object.assign(this, obj);
    }
}

export class GeneratedLicenseKeyInterface {
    headerTitle?: string = "";
    headerSubTitle?: string = "";
    licenseKey?: string = "";
    invoiceNo?: string = "";
    hideLicensePageButton?: boolean = false;
    onclickInvoiceNo?: () => void = () =>{};
    onclickLicenseKey?: () => void = () =>{};

    constructor(obj?: Partial<GeneratedLicenseKeyInterface>) {
        Object.assign(this, obj);
    }
}

export class CheckoutInterface {
    onClickBackBtn?: () => void = () =>{};
    formData?: any;
    isFromBilling?: boolean;
    checkoutData?: CheckoutData;
    isSuccessPayment?: boolean;
    setisSuccessPayment?: React.Dispatch<React.SetStateAction<boolean>>;

    constructor(obj?: Partial<CheckoutInterface>) {
        Object.assign(this, obj);
    }
}

export class CheckoutBillingInfoInterface {
    checkoutFormData?: any;
    setcheckoutFormData?: React.Dispatch<React.SetStateAction<any>>;
    formData?: any;
    setformData?: React.Dispatch<React.SetStateAction<any>>;
    selectedStep?: any;
    setselectedStep?: React.Dispatch<React.SetStateAction<any>>;
    stripeKey?: any;
    invoiceId?: any;
    setinvoiceId?: React.Dispatch<React.SetStateAction<any>>;
    licenseKey?: any;
    setlicenseKey?: React.Dispatch<React.SetStateAction<any>>;
    isFromBilling?: boolean;
    invoicePublicId?: any;
    setinvoicePublicId?: React.Dispatch<React.SetStateAction<any>>;
    licensePublicId?: any;
    setlicensePublicId?: React.Dispatch<React.SetStateAction<any>>;
    isSuccessPayment?: boolean;
    setisSuccessPayment?: React.Dispatch<React.SetStateAction<boolean>>;
    onClickBackBtn?: () => void = () =>{};

    constructor(obj?: Partial<CheckoutBillingInfoInterface>) {
        Object.assign(this, obj);
    }
}

export class StripeFormInterface {
    checkoutFormData?: any;
    setcheckoutFormData?: React.Dispatch<React.SetStateAction<any>>;
    formData?: any;
    setformData?: React.Dispatch<React.SetStateAction<any>>;
    selectedStep?: any;
    setselectedStep?: React.Dispatch<React.SetStateAction<any>>;
    stripeKey?: any;
    invoiceId?: any;
    setinvoiceId?: React.Dispatch<React.SetStateAction<any>>;
    licenseKey?: any;
    setlicenseKey?: React.Dispatch<React.SetStateAction<any>>;
    stepperItems?: any;
    isFromBilling?: boolean;
    invoicePublicId?: any;
    setinvoicePublicId?: React.Dispatch<React.SetStateAction<any>>;
    licensePublicId?: any;
    setlicensePublicId?: React.Dispatch<React.SetStateAction<any>>;
    isSuccessPayment?: boolean;
    setisSuccessPayment?: React.Dispatch<React.SetStateAction<boolean>>;
    onClickBackBtn?: () => void = () =>{};

    constructor(obj?: Partial<StripeFormInterface>) {
        Object.assign(this, obj);
    }
}

export class CustomStepperInterface {
    onClickStep?: (e: any) => void = () =>{};
    stepperItems?: any;
    selectedStep?: any;
    disableStepperOnClick?: boolean = false;

    constructor(obj?: Partial<CustomStepperInterface>) {
        Object.assign(this, obj);
    }
}

export class CustomStepContentInterface {
    stepHeader?: string = '';
    stepSubHeader?: string = '';
    children?: React.ReactNode = '';
    stepperItems?: any;
    selectedStep?: any;
    setselectedStep?: React.Dispatch<React.SetStateAction<any>>;
    hideprevStep?: boolean = false;
    hidenextStep?: boolean = false;
    validateStep?: (e: any) => void = () =>{};

    constructor(obj?: Partial<CustomStepContentInterface>) {
        Object.assign(this, obj);
    }
}

export class CustomUploadPhotoInterface {
    photoParams?: any;
    editPhotoParams?: any;
    seteditPhotoParams?: React.Dispatch<React.SetStateAction<any>>;
    viewType?: ViewType;
    sideTitle?: string;
    sideSubTitle?: string;

    constructor(obj?: Partial<CustomUploadPhotoInterface>) {
        Object.assign(this, obj);
    }
}

export class NewTabInterface {
    linkClassName?: any;
    linkTitle?: any;
    linkUrl?: any;

    constructor(obj?: Partial<NewTabInterface>) {
        Object.assign(this, obj);
    }
}

export class ConfirmPaymentDialogModel {
    openDialog?: boolean = false;
    handleClose: () => void = () =>{};
    buttonAction: (remarks: any) => void = (remarks: any) =>{};
    invoiceId?: string | number | null = 'this invoice';
    showRemarksField?: boolean = false;

    constructor(obj?: Partial<ConfirmPaymentDialogModel>) {
        Object.assign(this, obj);
    }
}